import store from "@/store";

export default function isNotSelectedFacility({ next, router }) {
  let hasSelectedFacility = store.getters["user/getHasSelectedFacility"];

  if (!hasSelectedFacility) {
    return next();
  }

  return router.push({ name: "Dashboard" });
}
